module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"views":{"start_page":{"header":{"tabs":{"news":"News & Updates","products":"Produkte"}}}}}}}')
  delete Component.options._Ctor
}
